import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { OwlMascot } from "@/components/OwlMascot";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? m[1] : null;

    (async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        // Clean the hash
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.user.role === "teacher" ? "/teacher" : "/dashboard", { state: { user: data.user } });
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <div className="anim-float"><OwlMascot size={140} talking /></div>
        <p className="mt-6 text-slate-600 font-mono text-sm">Fetching your feathers…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
